<template>
  <div class="integration-page-image-editor">
      <ImageUploader image_type="misc" @success="onUpload" v-if="!value">
        <BaseButton style="color: var(--green-5-color);" variant="primary" color="v1-grey-10" size="lg" class="green-5-color" icon="plus" />
      </ImageUploader>

      <ImageUploader image_type="misc" @success="onUpload" v-if="value">
        <BaseButton style="color: var(--yellow-4-color);" variant="primary" color="v1-grey-10" size="lg" class="yellow-4-color" icon="pencil" />
      </ImageUploader>

      <BaseButton style="color: var(--red-4-color);" variant="primary" color="v1-grey-10" size="lg" class="red-4-color" icon="trash" @click="$emit('input', null); $emit('delete')" v-if="value"/>
      
      <!-- <BaseButton variant="primary" /> -->
  </div>
</template>

<script>
import ImageUploader from "@/components/ImageUploader.vue"

export default {
  props: {
    value: String,
    isCover: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onUpload(sizes) {
      const value = this.isCover ? sizes.lg : sizes.md;
      this.$emit('upload', value)
      this.$emit('input', value);
    }
  },
  components: {
    ImageUploader
  }
}
</script>

<style scoped>
.integration-page-image-editor {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;

    background: rgba(var(--white-color), 0.64);

    backdrop-filter: blur(8px);

    row-gap: 16px;
    column-gap: 16px;
}

.integration-page-image-editor button {
  opacity: 1;
}
</style>